import axios from 'axios';
import { formatFireboltPayload } from './formatPayload';
import { FireboltPayload } from './types';
import { SHOffer } from '../sortingHat';

export async function sendFireboltSoftProposal(payload: FireboltPayload) {
  const baseURL = import.meta.env['VITE_FIREBOLT_API_URL'];

  try {
    const url = `${baseURL}/proposal/soft/${payload.partner}`;
    const payloadFormatted = formatFireboltPayload(payload);
    const options = {
      headers: {
        'Content-Type': 'application/json;',
        'x-api-key': import.meta.env['VITE_FIREBOLT_API_KEY'],
      },
    };

    const response = await axios.post(url, payloadFormatted, options);
    return response.data;
  } catch (error) {
    console.error('[ERROR ON FIREBOLT SOFT]', error);
  }
}

export async function startFullFunnelProposal(offer: SHOffer) {
  try {
    const baseURL = import.meta.env['VITE_FIREBOLT_API_URL'];
    const partner = offer.generalInfo.partner === 'bb' ? 'bb-npf' : offer.generalInfo.partner;
    const url = `${baseURL}/proposal/logged/start/${partner}`;
    const options = {
      headers: {
        'Content-Type': 'application/json;',
        'x-api-key': import.meta.env['VITE_FIREBOLT_API_KEY'],
      },
    };
    const response = await axios.get(url, options);
    return response.data;
  } catch (error) {
    console.error('[ERROR ON FIREBOLT LOGGED START]', error);
  }
}
